import axiosInstance from '../axios/axiosInstance';
import { ExerciseFormat } from '../model/response';

export const findAllExerciseFormats = async (subjectId?: string) => {
  const { data } = await axiosInstance.get<ExerciseFormat[]>('exercise-formats', {
    params: {
      subjectId,
      fromCMS: true,
    },
  });
  return data;
};

export const checkExistQuestion = (id: string) => {
  return axiosInstance.get(`/exercise-formats/${id}/check-exist-question`);
};

export const toggleExerciseFormatWebviewActive = async (id: string) => {
  await axiosInstance.patch(`exercise-formats/${id}/toggle-web-view-active`);
};

export const toggleExerciseFormatChild = async (id: string) => {
  await axiosInstance.patch(`exercise-formats/${id}/toggle-child`);
};
